import { render, staticRenderFns } from "./UserThumbnail.vue?vue&type=template&id=6c4dd616&scoped=true&"
import script from "./UserThumbnail.vue?vue&type=script&lang=js&"
export * from "./UserThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./UserThumbnail.vue?vue&type=style&index=0&id=6c4dd616&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4dd616",
  null
  
)

export default component.exports